import React from 'react';

const LegacyTrendIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="21" viewBox="0 0 16 21" fill="none">
      <path
        d="M4.5 12.5C5.16304 12.5 5.79893 12.2366 6.26777 11.7678C6.73661 11.2989 7 10.663 7 10C7 8.62 6.5 8 6 7C4.928 4.857 5.776 2.946 8 1C8.5 3.5 10 5.9 12 7.5C14 9.1 15 11 15 13C15 13.9193 14.8189 14.8295 14.4672 15.6788C14.1154 16.5281 13.5998 17.2997 12.9497 17.9497C12.2997 18.5998 11.5281 19.1154 10.6788 19.4672C9.82951 19.8189 8.91925 20 8 20C7.08075 20 6.17049 19.8189 5.32122 19.4672C4.47194 19.1154 3.70026 18.5998 3.05025 17.9497C2.40024 17.2997 1.88463 16.5281 1.53284 15.6788C1.18106 14.8295 1 13.9193 1 13C1 11.847 1.433 10.706 2 10C2 10.663 2.26339 11.2989 2.73223 11.7678C3.20107 12.2366 3.83696 12.5 4.5 12.5Z"
        stroke="#A2A2A2"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
    </svg>
  );
};

export default LegacyTrendIcon;
